exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#confirmation-view {\n  text-align: left; }\n  #confirmation-view .confirm_container {\n    width: 100%; }\n  #confirmation-view .signup-info-box-wrapper {\n    width: 100%; }\n  #confirmation-view .signup-info-box {\n    padding: 10px 20px;\n    border: 2px dashed #7D0101; }\n  #confirmation-view .nces-search-input-component {\n    padding-top: 10px;\n    width: 100%; }\n  #confirmation-view .modal-body-content {\n    width: 80%;\n    margin-left: 10%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/modal/create-account-modal/confirmation-view.sass
// module id = 847
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91